import { render, staticRenderFns } from "./footer-disclaimer.vue?vue&type=template&id=6fae4e9a&"
import script from "./footer-disclaimer.vue?vue&type=script&lang=ts&"
export * from "./footer-disclaimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports